import { useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { useSelectedProject } from "Hooks";
import useProtectedRoutes from "Hooks/useProtectedRoutes";
import { RouteNames } from "Hooks/routeNames";
import { IStoreState } from "Interfaces";
import { clearTrialExpired } from "Actions";

export default function TrialExpiredRedirectListener() {
  const history = useHistory();
  const location = useLocation();
  const dispatch = useDispatch();
  const { selectedProject } = useSelectedProject();
  const { pathByName } = useProtectedRoutes();
  const trialExpiredFlag = useSelector(
    (state: IStoreState) => state.auth.trialExpired
  );

  useEffect(() => {
    if (!trialExpiredFlag) {
      return;
    }

    const clientId = selectedProject?.clientId;
    const projectId = selectedProject?.id;
    if (!clientId || !projectId) {
      return;
    }

    const path = pathByName(RouteNames.ACCOUNT_PAYMENT, { clientId, projectId });
    if (!path) {
      return;
    }
    if (location.pathname === path) {
      dispatch(clearTrialExpired());
      return;
    }

    history.push(path);
    dispatch(clearTrialExpired());
  }, [
    trialExpiredFlag,
    history,
    location.pathname,
    pathByName,
    selectedProject?.clientId,
    selectedProject?.id,
    dispatch,
  ]);

  return null;
}

